import { Engine1Proxy, RestApiProxy, SagasProxy } from 'com-gyf-webcore-servicehub';

let UsuarioManager = function () {    
    /**
     * 
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function _guardarUsuario(data, sagasCallback, viewCallback) {
        if (data.USUARIOS_TO_DELETE_BLOCK_UNBLOCK) {
            //Caso de bloqueo, desbloqueo o eliminacion
            let localValues = mapearUsuarioDeleteBlock(data);
            ejecutarSagas(localValues, 'SAGA_ELIMINAR_BLOQUEAR_USUARIO', sagasCallback, viewCallback);
        }
        else {
            let localValues = mapearUsuario(data);
            ejecutarSagas(localValues, 'SAGA_NUEVO_USUARIO', sagasCallback, viewCallback);
        }
    }

    /**
     * 
     * @param {any} data
     */
    function mapearUsuarioDeleteBlock(data) {
        let localValues = { "UsuariosState": [] };

        data.USUARIOS_TO_DELETE_BLOCK_UNBLOCK.forEach((user) => {
            localValues.UsuariosState.push({
                "ID": user.ID,
                "ELIMINADO_POR": user.ELIMINADO_POR ? user.ELIMINADO_POR : null,
                "BLOQUEADO_POR": user.BLOQUEADO_POR ? user.BLOQUEADO_POR : null,
                "FECHA_ELIMINADO": user.ELIMINADO_POR ? GetActualDate() : null,
                "FECHA_BLOQUEO": user.BLOQUEADO_POR ? GetActualDate() : null,
                "ACTIVO": user.ACTIVO,
                "BLOQUEADO": user.BLOQUEADO 
            });
        });

        return localValues;
    }

    /**
     * 
     * @param {any} data
     */
    function mapearUsuario(data) {
        let localValues = {
            "USUARIO": {
                "ID": (data.USUARIO_ID) ? data.USUARIO_ID : null,
                "NOMBRE": data.NOMBRE,
                "LOGIN": data.LOGIN,
                "EMAIL": data.EMAIL,
                "CODIGO_PERSONA": data.CODIGO_PERSONA,
                "LOGIN_NT": data.LOGIN_NT,
                "BLOQUEADO": data.BLOQUEADO, 
                "BLOQUEADO_INACTIVIDAD": data.BLOQUEADO_INACTIVIDAD,
                "CLAVE": data.CLAVE,
                "CAMBIO_CLAVE": data.CAMBIO_CLAVE,
                "CANT_CAMBIOS_CLAVE": data.CANT_CAMBIOS_CLAVE,
                "ULTIMO_CAMBIO_CLAVE": data.ULTIMO_CAMBIO_CLAVE ? null : GetActualDate(),
                "ACTIVO": data.ACTIVO,
                "SECTOR_ID": validarIds(data.SECTOR_ID),
                "TIPO_DOCUMENTO": validarIds(data.TIPO_DOCUMENTO),
                "DOCUMENTO": data.DOCUMENTO, 
                "SUCURSAL_ID": data.SUCURSAL_ID,
                'FECHA_ALTA': (data.USUARIO_ID) ? data.FECHA_ALTA : GetActualDate(),

                "UltimasPassword": [],
                "Terminales": [],
                "Perfiles": data.PERFILES,
                "Sucursales": [],
                "LogsPlataforma": [],
                "ListCanLog": data.PLATAFORMAS,
                "Permisos": data.PERMISOS,
                "ModosExclusivos": data.EXCLUSIVEMODES,
                "PLATAFORMA_ID": data.PLATAFORMA_ID
            }
        }

        return localValues;
    }

    /**
     * 
     * @param {any} id
     */
    const validarIds = (id) => (id > 0 ? id : null);

    /**
     * 
     */
    function GetActualDate() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; 
        var yyyy = today.getFullYear();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }

        today = mm + '/' + dd + '/' + yyyy;

        return today + " " + time;
    }

    /**
     * 
     * @param {any} localValues
     * @param {any} saga
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {
        SagasProxy.AddSagaRequests(localValues, saga, "CONCIERGE", "SEGURIDAD");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, null, null, "SEGURIDAD");
    }

    return {
        GuardarUsuario: function (data, sagasCallback, viewCallback) {
            return _guardarUsuario(data, sagasCallback, viewCallback);
        }
    }
};

let usuarioManager = new UsuarioManager();
export default usuarioManager;